<template>
  <div class="box box__primary box__dark text-center box__header-title"
       v-bind:class="{'box__header-title-slim': $route.meta.slimHeader}">
    <h2>Trabalhar</h2>
  </div>
</template>

<script>
export default {
  name: 'ProfessionalPreRegisterHeader'
}
</script>
